module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "waterfall"
  }, _vm._l((_vm.columns), function(column, index) {
    return _c('div', {
      key: index,
      staticClass: "waterfall-column"
    }, _vm._l((column), function(item, i) {
      return _c('div', {
        key: i,
        staticClass: "waterfall-item"
      }, [_c('img', {
        attrs: {
          "width": "100%",
          "src": item.src,
          "alt": item.alt
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "waterfall-item-content"
      }, [_c('div', {
        staticClass: "waterfall-item-title"
      }, [_vm._v(_vm._s(item.title))])])])
    }), 0)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8d195f44"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/picFall.vue
// module id = 81
// module chunks = 0